import { Box, Typography, Button } from '@mui/material';
import NoteTakerWrapper from 'pages/Dashboard/components/SessionRecording/NoteTakerWrapper';
import React from 'react';
import theme from 'theme';
import { ReactComponent as Browsers } from 'assets/Browsers.svg';

function BrowserNotSupported({
  setIsDrawerOpen,
}: {
  setIsDrawerOpen: (isOpen: boolean) => void;
}) {
  return (
    <NoteTakerWrapper title='Browser not supported' setIsDrawerOpen={setIsDrawerOpen}>
      <Box display='flex' flexDirection='column' alignItems='center' my={6}>
        <Typography variant='h4' color={theme.custom.colors.lightTextPrimary}>
          You seem to be using unsupported browser
        </Typography>
        <Typography variant='body1' color={theme.custom.colors.lightTextSecondary} my={3}>
          Please use another browser to use this feature.
        </Typography>
        <Typography variant='body1' color={theme.custom.colors.lightTextSecondary}>
          Supported browsers are
          {' '}
          <Typography fontWeight={700} component='span' color={theme.custom.colors.primaryMain}>
            Chrome
          </Typography>
          ,
          {' '}
          <Typography fontWeight={700} component='span' color={theme.custom.colors.primaryMain}>
            Edge
          </Typography>
          , and
          {' '}
          <Typography fontWeight={700} component='span' color={theme.custom.colors.primaryMain}>
            Firefox
          </Typography>
        </Typography>
        <Box height={60} width={250} my={5}>
          <Browsers width='100%' height='100%' preserveAspectRatio='none' />
        </Box>
        <Button onClick={() => setIsDrawerOpen(false)} variant='contained' sx={{ mt: 5 }}>
          GOT IT!
        </Button>
      </Box>
    </NoteTakerWrapper>
  );
}

export default BrowserNotSupported;
